import type { ReactNode } from 'react';
import MgoNavigation from '@humanforce/mango-ui/dist/react/navigation/index.js';
import MgoNavigationItem from '@humanforce/mango-ui/dist/react/navigation-item/index.js';
import { asMangoElement } from './mango';

const MangoNavigation = asMangoElement(MgoNavigation);
const MangoNavigationItem = asMangoElement(MgoNavigationItem);

interface NavigationProps {
  children: ReactNode;
  slot?: string;
}

interface NavigationItemProps {
  active?: boolean;
  children: ReactNode;
  onClick: () => void;
}

export const Navigation = ({ children, slot }: NavigationProps) => {
  return <MangoNavigation slot={slot}>{children}</MangoNavigation>;
};

export const NavigationItem = ({ active, children, onClick }: NavigationItemProps) => {
  return (
    <MangoNavigationItem active={active ? true : undefined} onClick={onClick}>
      {children}
    </MangoNavigationItem>
  );
};
